<template>
	<span>
		<sf-data-table
			height="100%"
			paging
			excel
			:columns="dayCols"
			:rows="resultList"
			:pageUnit="groups.pageUnit"
			:totalSize="groups.totalSize"
			:currentPage="groups.currentPage"
			:pageArray="screen.pageArray"
			@changedPage="changedPage"
		/>
	</span>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/ScreenUsage/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	data() {
		return { screen: {} };
	},

	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			this.$emit('refresh', currentPageVal, pageUnitVal);
		},
		tableRowClassName({ row, rowIndex }) {
			if (row.userName === 'SUM') {
				return 'highlight-row';
			}
			return '';
		}
	}
};
</script>

<style>
.el-table .highlight-row {
	background: oldlace !important;
}
</style>
